module.exports = __webpack_public_path__ + "officialStatic/img/solution4.04733c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/solution4.png
// module id = em8n
// module chunks = 0